import { Box, Stack, Typography } from "@mui/material";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";

const CustomPagination = ({
  page,
  totalPages,
  onPageChange,
  scrollRef,
}) => {
  return (
    <Stack direction="row" justifyContent="space-between" >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 1,
          gap: 1,
          height:"100%"
        }}
      >
        <Typography fontSize="12px">Page</Typography>

        {/* Prev */}
        <button
          disabled={page === 0}
          onClick={() => {
            if (page > 0) {
              onPageChange(page - 1);
              scrollRef?.current && (scrollRef.current.scrollTop = 0);
            }
          }}
        >
          <KeyboardArrowLeftOutlinedIcon fontSize="small" />
        </button>

        {/* Page input */}
        <input
          key={page}
          defaultValue={page + 1}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              const value = parseInt(e.target.value);
              let newPage = 0;

              if (!isNaN(value)) {
                newPage = Math.min(
                  Math.max(value - 1, 0),
                  totalPages - 1
                );
              }

              onPageChange(newPage);
              scrollRef?.current && (scrollRef.current.scrollTop = 0);
              e.target.blur();
            }
          }}
          onFocus={(e) => e.target.select()}
          style={{
            width: 50,
            textAlign: "center",
            fontSize: 12,
          }}
        />

        {/* Next */}
        <button
          disabled={page >= totalPages - 1}
          onClick={() => {
            if (page < totalPages - 1) {
              onPageChange(page + 1);
              scrollRef?.current && (scrollRef.current.scrollTop = 0);
            }
          }}
        >
          <KeyboardArrowRightOutlinedIcon fontSize="small" />
        </button>

        <span style={{ fontSize: 14 }}>of {totalPages}</span>
      </Box>
    </Stack>
  );
};

export default CustomPagination;
